import React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

library.add(faArrowLeft);
export default function goBack(props) {
  return (
    <div onClick={() => props.clickHandler()}>
      <FontAwesomeIcon icon="arrow-left" style={styles.arrow} />
    </div>
  );
}

const styles = {
  arrow: {
    fontSize: "30px",
    margin: "7px 0 7px 5px"
  }
};
